import { axiosDelete, axiosGet, axiosPost, axiosPut, getSeparator } from "@/helpers";

export const cargoSpace = {
  list,
  listByTransport,
  create,
  detail,
  update,
  remove,
};

function list(page, itemsPerPage, sort, search) {
  let url = "/api/v1/cargo-spaces/";
  if (page) {
    url += `?page=${page}&page_size=${itemsPerPage}`;
  }
  if (sort) {
    url += `${getSeparator(url)}ordering=${sort}`;
  }
  if (search) {
    url += `${getSeparator(url)}search=${search}`;
  }

  url += `${getSeparator(url)}`;

  return axiosGet(url);
}

function listByTransport(transportId) {
  return axiosGet(`/api/v1/cargo-spaces/?transport=${transportId}`);
}

function create(data) {
  return axiosPost("/api/v1/cargo-spaces/", data);
}

function detail(id) {
  return axiosGet(`/api/v1/cargo-spaces/${id}/`);
}

function update(id, data) {
  return axiosPut(`/api/v1/cargo-spaces/${id}/`, data);
}

function remove(id) {
  return axiosDelete(`/api/v1/cargo-spaces/${id}/`);
}
